import {radioBoxTriState} from '@components/radio-box/radio-box-filter.util';

/** Backend ExtractFilters parses isTakenIntoAccount via bool.TryParse(FilterValue.ToString()). */
const TAKEN_INTO_ACCOUNT_FILTER_VALUE = {
  yes: 'true',
  no: 'false',
} as const;

/** UI filter value for isTakenIntoAccount: null = all rows (true and false), true/false = exact match. */
export function appendTakenIntoAccountFilter(
  filters: Array<{filterField?: string | null; filterOperator?: number; filterValue?: unknown}>,
  value: unknown,
  filterOperator = 0,
): void {
  const taken = radioBoxTriState(value);
  if (taken === true) {
    filters.push({
      filterField: 'isTakenIntoAccount',
      filterOperator,
      filterValue: TAKEN_INTO_ACCOUNT_FILTER_VALUE.yes,
    });
  } else if (taken === false) {
    filters.push({
      filterField: 'isTakenIntoAccount',
      filterOperator,
      filterValue: TAKEN_INTO_ACCOUNT_FILTER_VALUE.no,
    });
  }
}
